import * as React from "react";

function SvgCartWhiteIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M.518 1.024h1.485l2.114 7.56c.06.222.268.376.501.376h6.5a.52.52 0 00.475-.307l2.365-5.376a.513.513 0 00-.475-.717H6.301a.517.517 0 00-.518.512c0 .282.234.512.518.512h6.388l-1.916 4.352H5.007L2.892.376a.517.517 0 00-.5-.376H.517A.517.517 0 000 .512c0 .282.233.512.518.512zM3.92 12.32a1.121 1.121 0 000-2.24 1.121 1.121 0 000 2.24zM11.196 12.32h.083a1.12 1.12 0 00.767-.387c.198-.222.289-.51.272-.814a1.124 1.124 0 00-1.196-1.037 1.122 1.122 0 00-1.04 1.193 1.123 1.123 0 001.114 1.045z"
                fill="#FFF"
            />
        </svg>
    );
}

export default SvgCartWhiteIcon;
